import Param from '../../param.js';

let param = new Param();

export default class sliderManager {
    constructor(pageID,scroll){

        //dom
        this.slider = document.querySelectorAll('.js__slider');
        this.swipper = document.querySelectorAll('.swiper-container');

        this.showPc = [];
        this.showSmp = [];
        this.loop = [];
        this.auto = [];
        this.mySwiper = [];

        this.space = 9;

        this.status = {
            load : false,
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp",
            scroll : false
        }

        this.pageID = pageID;
        this.scroll = scroll;

    }
    init(){

        if(this.pageID === 'top'){
            this.space = 21;
        }

        for(var i=0; this.slider.length>i; i++){
            this.showPc[i] = (Useragnt.userAgent.match(/FB/))?1:this.slider[i].dataset['showpc'];
            this.showSmp[i] = this.slider[i].dataset['showsmp'];
            this.loop[i] = this.slider[i].dataset['loop'];//''空だとfalse
            if(this.pageID === 'top' && i === 0 && this.status.scroll){
                this.auto[i] = true;
            }else{
                this.auto[i] = false;
            }
            this.mySwiper[i] = new Swiper (this.swipper[i], {
                loop: !!this.loop[i],
                speed: 400,
                slidesPerView: this.showPc[i],
                spaceBetween: this.space,
                direction: 'horizontal',
                effect: 'slide',
                initialSlide: 0,
                autoplay:this.auto[i],
                autoplayDelay: 8000,
                // autoplay: {
                //     delay: this.auto[i], // スライドが切り替わるまでの表示時間(ミリ秒)
                //     stopOnLast: false, // 最後のスライドまで表示されたら自動再生を中止するか
                //     disableOnInteraction: true // ユーザーのスワイプ操作を検出したら自動再生を中止するか
                // },

                pagination: {
                    el: this.slider[i].querySelector('.swiper-pagination'),
                    type: 'bullets',
                },

                navigation: {
                    nextEl: this.slider[i].querySelector('.swiper-button-next'),
                    prevEl: this.slider[i].querySelector('.swiper-button-prev'),
                },

                breakpoints: {
                    // 980ピクセル幅以下になったら
                    750: {
                        slidesPerView: this.showSmp[i],
                        spaceBetween: 15,
                    },
                },

                // scrollbar: {
                //     el: '.swiper-scrollbar', // スクロールバーを表示するセレクタ
                // }

            });
        }

    }

    set(){

        if(this.status.load){

            for (var i = 0; this.slider.length > i; i++) {
                this.mySwiper[i].destroy(true,true);
            }

        }

        this.init();

        for (var i = 0; this.slider.length > i; i++) {
            if(this.status.device ==='pc'){
                if(this.showPc[i] === '-1'){
                    this.mySwiper[i].destroy(true,true);
                }
            }else{
                if(this.showSmp[i] === '-1'){
                    this.mySwiper[i].destroy(true,true);
                }
            }
        }

        this.status.load = true;

    }

    render() {
        if(this.pageID !== 'top' || this.status.scroll) return;
        if(this.scroll.inc > window.innerHeight / 1.8){
            this.status.scroll = true;
            this.set();
        }
    }


    resize(_w,_h){
        if(_w>param.breakpoint){
            if(this.status.device==="sp"){
                this.status.device = "pc";
                this.set();
            }

        }else{
            if(this.status.device==="pc"){
                this.status.device = "sp";
                this.set();
            }
        }
    }


}